module.exports = __webpack_public_path__ + "img/TradingView-img3.6e25a295.png";